import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'
import { Eye, EyeOff } from 'lucide-react'
import type { ComponentProps } from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

type PasswordInputProps = Omit<ComponentProps<typeof Input>, 'type'>

export function PasswordInput({ className, ...props }: PasswordInputProps) {
  const { t } = useTranslation()
  const [showPassword, setShowPassword] = useState(false)

  return (
    <div className="relative">
      <Input
        {...props}
        type={showPassword ? 'text' : 'password'}
        className={cn('pr-9', className)}
        autoComplete={props.autoComplete ?? 'new-password'}
      />
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="absolute right-1 top-1/2 size-7 -translate-y-1/2 text-muted-foreground hover:text-foreground"
        onClick={() => setShowPassword(value => !value)}
      >
        {showPassword ? <EyeOff className="size-3.5" /> : <Eye className="size-3.5" />}
        <span className="sr-only">{showPassword ? t('common.hidePassword') : t('common.showPassword')}</span>
      </Button>
    </div>
  )
}
